import { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { findRhymes, syllables } from "@/lib/poetry/dict";
import { docLines, lastWord } from "@/lib/poetry/lines";

export const currentLine = (editor) => {
  if (!editor) return null;
  const at = editor.state.selection.from;
  return docLines(editor.state.doc).find((l) => at >= l.start && at <= l.end) || null;
};

const Chips = ({ list, pick, testid }) => (
  <div className="flex flex-wrap gap-1" data-testid={testid}>
    {list.map((w) => <button key={w} onClick={() => pick(w)} className="rounded-full border border-[#2D3442] px-2 py-0.5 text-xs text-[#E8DFD1] transition-colors hover:border-[#D97706] hover:text-[#FBBF24]" data-testid={`rhyme-word-${w}`}>{w}</button>)}
  </div>
);

const bySyl = (list) => {
  const g = {};
  list.forEach((w) => { const n = Math.min(4, syllables(w)); (g[n] = g[n] || []).push(w); });
  return Object.entries(g).sort((a, b) => a[0] - b[0]);
};

export const RhymesTab = ({ editor, onInsert }) => {
  const [q, setQ] = useState("");
  const auto = lastWord(currentLine(editor)?.text || "");
  const word = (q.trim().split(/\s+/).pop() || auto).toLowerCase();
  const { perfect, near } = word ? findRhymes(word, 80) : { perfect: [], near: [] };
  const pick = (w) => { if (onInsert) onInsert(w); else navigator.clipboard?.writeText(w); };
  return (
    <div className="space-y-3" data-testid="poetry-rhymes">
      <div className="relative"><Search className="absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[#7A7468]" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder={auto ? `Rhymes for “${auto}” (current line)` : "Type a word"} className="h-8 pl-8 text-sm" data-testid="rhyme-search" /></div>
      {!word && <p className="text-xs text-[#7A7468]">Put your cursor on a line or type a word.</p>}
      {word && <p className="text-xs text-[#A8A090]" data-testid="rhyme-target">Rhymes for <b className="text-[#F3EBDD]">{word}</b> · {syllables(word)} syllable{syllables(word) === 1 ? "" : "s"}{onInsert ? " · click a word to insert it" : ""}</p>}
      {word && (
        <div className="max-h-80 space-y-3 overflow-y-auto pr-1">
          <div className="space-y-1.5"><div className="lf-label">Perfect rhymes</div>
            {perfect.length ? bySyl(perfect).map(([n, l]) => <div key={n} className="space-y-1"><div className="text-[10px] text-[#7A7468]">{n === "4" ? "4+" : n} syllable{n === "1" ? "" : "s"}</div><Chips list={l} pick={pick} testid={`rhyme-perfect-${n}`} /></div>)
              : <p className="text-xs text-[#7A7468]" data-testid="rhyme-perfect-empty">No perfect rhymes found.</p>}</div>
          <div className="space-y-1.5"><div className="lf-label">Near rhymes</div>
            {near.length ? <Chips list={near.slice(0, 50)} pick={pick} testid="rhyme-near" /> : <p className="text-xs text-[#7A7468]">None found.</p>}</div>
        </div>
      )}
    </div>
  );
};
